import React, { useCallback } from 'react'
import './styles.scss'
import axios from 'axios'
import { toast } from 'react-toastify'

interface IProps {
  fileName: any
  uploadedFilesApi: any
  closeDeleteModal: () => void
}

const DeleteFile: React.FC<IProps> = ({ fileName, uploadedFilesApi, closeDeleteModal }) => {
  const deleteFile: any = useCallback(async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_CSV_ANALYTICS_URL}/csv-analytics/delete?filename=${fileName}`,
        { withCredentials: true }
      )
      toast.success(response?.data?.message)
      closeDeleteModal()
      uploadedFilesApi()
    } catch (error) {
      console.log(error, 'error')
    }
  }, [])

  return (
    <div>
      <div
        style={{
          borderTop: '1px solid hsl(240, 17.4%, 91%)',
          borderBottom: '1px solid hsl(240, 17.4%, 91%)',
          padding: '10px 0'
        }}
      >
        <p style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '14px' }}>
          Are you sure you want to delete the project "data (3)"? <br></br>This action is
          irreversible.
        </p>
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
        <button
          style={{
            background: 'hsl(10, 87.8%, 48%)',
            color: 'white',
            border: '1px solid hsl(9.9, 87.6%, 38%)',
            padding: '4px 8px',
            borderRadius: '4px',
            boxShadow: '0px 1px 2px 0px rgba(18, 18, 23, .05)',
            marginBottom: '-10px'
          }}
          onClick={() => deleteFile()}
        >
          Delete Project
        </button>
      </div>
    </div>
  )
}

export default DeleteFile
